import { Button, Space } from "antd";
import { useContext, useState } from "react";
import { EmbedConfigContext, authOptionsKey, baseOptionsKey, searchOptionsKey } from "../EmbedConfigContext";
import useAuthProvider from "../useAuthProvider";

const SidebarPage = () => {
  const { config } = useContext(EmbedConfigContext);
  const authParams = useAuthProvider(config[authOptionsKey], config[baseOptionsKey].backend);
  const [shouldShowArticle, setShouldShowArticle] = useState(false);

  const openSidebar = async () => {
    if (!window.GleanWebSDK) {
      return
    }

    try {
      await window.GleanWebSDK.openSidebar({
        ...config[baseOptionsKey],
        ...config[searchOptionsKey],
        ...authParams,
        onSearch: () => {},
      });
    }
    catch(error){}
  }

  const toggleArticle = () => {
    setShouldShowArticle(!shouldShowArticle)
  }

  return (
    <article className="mx-auto max-w-4xl px-5 py-12 text-base leading-relaxed">
      <Space direction="horizontal" className="mb-8">
        <Button type="primary" size="large" onClick={openSidebar}>
          Open Sidebar
        </Button>
        <Button  type="primary" size="large" onClick={toggleArticle}>
          {shouldShowArticle ? 'Hide article' : 'Show article'}
        </Button>
      </Space>

      {shouldShowArticle && (<>
        <h1 className="mb-8 text-3xl font-semibold leading-tight text-gray-900 sm:text-4xl">
          Glean adds support for NVIDIA Nemotron 3 Ultra, expanding model choice for cost-effective enterprise AI
        </h1>

        <p className="mb-6">
          Enterprise AI leader Glean, today announced support for NVIDIA Nemotron 3 Ultra, expanding the set of models available in Glean’s platform and giving customers a new open model option for cost-effective agentic work.
        </p>

        <p className="mb-6">
          The Nemotron 3 Ultra open model gives customers strong agentic capabilities for everyday enterprise work, delivering 91% of frontier LLM completeness with the cost profile of an open model. With Nemotron 3 Ultra available in Glean, customers have more flexibility in how they deploy AI across the business. Rather than forcing every task through a single model family, Glean helps organizations choose the best model for the job and orchestrate it within a secure, context-aware enterprise platform.
        </p>

        <p className="mb-6">
          “Enterprises are moving beyond the idea that one model should do everything,” said Emrecan Dogan, Chief Product Officer, Glean. “They want the ability to match the right model to the right task, and they need a cost-effective way to bring AI into everyday work. Our support for NVIDIA Nemotron 3 Ultra reflects that reality and gives customers a strong option as they scale AI across the enterprise.”
        </p>

        <p className="mb-6">
          “Glean is bringing NVIDIA Nemotron 3 Ultra into enterprise AI workflows where model choice, cost, and performance are critical,” said Kari Briski, Vice President of Generative AI, NVIDIA. “Together, we’re helping companies deploy open models for everyday work at scale.”
        </p>

        <p className="mb-6">
          Today’s announcement underscores Glean’s long-standing model-agnostic platform strategy: enterprises should be able to build across an ecosystem of models, not rely on a single provider. With access to 30+ models, including Nemotron 3 Ultra, Glean customers can take advantage of the latest open source and proprietary advances with stronger performance, lower cost, and the flexibility to avoid provider lock-in as AI evolves rapidly.
        </p>

        <p className="mb-8">
          The work with NVIDIA is a continuation of our collaboration across the Nemotron family of models. Glean Waldo, an agentic search model, is post-trained on NVIDIA Nemotron 3 Nano and delivers 50% lower latency and 25% fewer tokens. Waldo takes on the search tasks that frontier models used to handle, preserving their reasoning and response capacity for work that actually requires it. This is a blueprint for how Glean approaches token economics: multiple models working together to deliver frontier-level intelligence with fewer tokens.
        </p>
      </>)}
    </article>
  );
};

export default SidebarPage;
